function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 62,
  height: 50,
  rx: 4
}), /*#__PURE__*/React.createElement("filter", {
  x: "-5.6%",
  y: "-5.0%",
  width: "111.3%",
  height: "114.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.148973585 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "00-Home-Collapsed-Menu",
  transform: "translate(-15.000000, -17.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(17.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000098",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-3",
  stroke: "#FFFFFF",
  transform: "translate(46.853031, 24.500000) scale(-1, 1) translate(-46.853031, -24.500000) ",
  points: "50.8530306 17 42.8530306 24.989894 50.8530306 32"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.02437323,13 C0.906247141,13 0,13.7281739 0,14.6265377 L0,15 L13,15 L13,14.6265377 C13,13.7281739 12.0936042,13 10.9754781,13 L2.02437323,13 Z",
  id: "Fill-24",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,6.00007231 C1,2.6204669 3.68715197,0 7.15295212,0 C8.70995187,0 10.0412178,0.489846095 10.9702563,1.17565955 C11.4725956,1.54286334 11.6984778,1.93479807 11.6984778,2.40005785 C11.6984778,3.012257 11.1962868,3.50210309 10.4931304,3.50210309 C10.1917564,3.50210309 9.86531746,3.37975004 9.51366511,3.13475468 C8.8858522,2.66935027 8.08228727,2.37561616 7.20308223,2.37561616 C5.06839969,2.37561616 3.46097321,3.96736288 3.46097321,6.00007231 C3.46097321,8.00805081 5.06839969,9.62452846 7.2282956,9.62452846 C8.28295603,9.62452846 9.18722612,9.25718005 9.86531746,8.66942258 C10.1162646,8.42442722 10.4931304,8.22860449 10.8698478,8.22860449 C11.5227257,8.22860449 12,8.74289227 12,9.3795331 C12,9.67355646 11.8743781,9.99173225 11.5227257,10.383667 C10.5683255,11.3878009 8.8858522,12 7.15295212,12 C3.68715197,12 1,9.35509142 1,6.00007231 Z",
  id: "Fill-26",
  fill: "#FF6A13"
})))));

function SvgLogoCollapsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "54px",
    viewBox: "0 0 66 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Header Logo collapsed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapsed);
export default __webpack_public_path__ + "static/media/logo-collapsed.faa9a11f.svg";
export { ForwardRef as ReactComponent };